import { defineComponent as _defineComponent } from 'vue'
import { decodeMessageText } from '../util';

interface Props {
    data:string,
    // avatar:string,
    // clientTime:number,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MessageText',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
    data:string,
    // avatar:string,
    // clientTime:number,
}

  

  console.log("------------------------------消息-----------------------------------")

  const handleTextMessageShowContext = (text: string) => {
    let result = decodeMessageText(text);
    return result;
  }


return { __sfc: true,props, handleTextMessageShowContext }
}

})